module.exports = __webpack_public_path__ + "img/zep2.b5a0665c.jpg";